export const getIp = async () => {
  try {
    const response = await axios({
      method: "GET",
      url: "https://geolocation-db.com/json/",
    });
    return response?.data?.IPv4;
  } catch {
  }
};
